import React, { memo, useEffect, useRef, useState } from 'react';
import { Button, FloatingLabel, Form, Modal } from 'react-bootstrap';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { RiSearchLine } from '../../../../components/icons';
import { doctube_playlist_details_static_image } from '../../../../common/assets.common';
import '../scss/dt_playlistDetails.scss';
import {
  useAddPlaylist,
  useAddVideoToPlaylist,
  useCategoryList,
  useDoctubeSearchPlaylist
} from '../../../../Queries/QueryHooks/doctube.hook';
import { MultiselectComponent } from '../components/MultiselectComponent';
// import ReactHtmlParser from 'react-html-parser';
import useDebounce from '../../../../components/customHooks/useDebounce';
import NoResult from '../../../../components/noResult/NoResult';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from 'react-loader-spinner';
import useRedirect from '../../../../components/customHooks/useRedirect';
import { toast } from 'react-toastify';
import { useInView } from 'react-intersection-observer';
import { reactHtmlParser } from '../../../../common/common';

const CreatePlaylistModal = ({ show, onHide }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [subCategories, setSubCategories] = useState([]);
  const [userInput, setUserInput] = useState({
    category_id: '',
    sub_category: ''
  });
  const [playListName, setPlaylistName] = useState('');
  const [tags, setTags] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [word, setWord] = useState('');
  const [videoIds, setVideoIds] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const debouncedSearchTerm = useDebounce(word, 1000);
  console.log('debouncedSearchTerm', debouncedSearchTerm);
  // const videoIdsRef = useRef([]);
  const { redirectTo } = useRedirect();
  const apiCallFlag = useRef(false);

  const onSuccessAddPlaylistCb = (response) => {
    console.log('success callback', response.data.data);
    onHide();

    // redirectTo('DoctubePlaylistDetails', response.data.data);
    redirectTo('DoctubeManagePlaylist');
    // setDisabled(false);
    setTimeout(() => {
      setDisabled(false);
      setUserInput({
        category_id: '',
        sub_category: ''
      });
      setPlaylistName('');
      setTags('');
      setVideoIds([]);
    }, 1000);
    if (response.status == 200) {
      toast.success(`Your ${playListName} playlist has been created.`);
    }
  };
  const { mutate, data, error } = useAddPlaylist(onSuccessAddPlaylistCb);
  const createPlaylist = () => {
    let formData = new FormData();
    formData.append('name', playListName);
    formData.append('category_id', userInput.category_id);
    formData.append('sub_category_id', userInput.sub_category);
    formData.append('tags', tags);
    formData.append('video_id', videoIds.toString());
    if (playListName != '') {
      if (userInput.category_id != '') {
        if (userInput.sub_category != '') {
          if (tags != '') {
            setDisabled(true);
            mutate(formData);
            // console.log('create playlist', {
            //   Name: playListName,
            //   Category_id: userInput.category_id,
            //   Sub_category_id: userInput.sub_category,
            //   Video_id: videoIds
            // });
          } else {
            toast.error('Please enter tags for patients to easily find your videos');
          }
        } else {
          toast.error('Please select a sub category');
        }
      } else {
        toast.error('Please select a category');
      }
    } else {
      toast.error('Please enter Playlist Name');
    }
    // console.log('add video data', data);
    // addVideos(formData);
    console.log('create playlist', {
      Name: playListName,
      Category_id: userInput.category_id,
      Sub_category_id: userInput.sub_category,
      Video_id: videoIds
    });
  };

  const selectedCatagory = (selectedItem) => {
    console.log('SELECTED_CATEGORY', selectedItem);
    setSubCategories(categories?.find((c) => c.id == selectedItem)?.sub_categories);
    setUserInput((prev) => {
      return {
        ...prev,
        category_id: selectedItem
      };
    });
  };
  const selectedSubcategory = (selectedItem) => {
    console.log('SELECTED_SUB_CATEGORY', selectedItem);
    setUserInput((prev) => {
      return {
        ...prev,
        sub_category: selectedItem
      };
    });
  };
  // console.log('USER_INPUT', userInput);
  const addVideoHandler = (data) => {
    let vidId = data?.id;
    let isChecked = videoIds.includes(vidId);
    if (!isChecked) {
      // videoIdsRef.current = [...videoIdsRef.current, vidId];
      setVideoIds([...videoIds, vidId]);
    } else {
      // videoIdsRef.current = videoIdsRef.current.filter((i) => i != vidId);
      setVideoIds(videoIds.filter((i) => i != vidId));
    }
    // console.log('videoIdsRef.current', videoIdsRef.current);
  };
  const onSuccess = (data) => {
    apiCallFlag.current = true;
    console.log('success', data);
    setFilterData(() => {
      if (data) {
        let arrayTemp = data?.pages?.map((page) => page?.data?.data)?.flat();
        return arrayTemp;
      } else {
        return [];
      }
    });
  };
  const onError = () => { };
  const {
    data: searchData,
    isLoading,
    fetchNextPage,
    hasNextPage
  } = useDoctubeSearchPlaylist(debouncedSearchTerm, show, onSuccess, onError);
  const handleSearch = (e) => {
    setIsOpen(true);
    setWord(e.target.value);
    console.log('search', e.target.value);
  };
  const { data: categories } = useCategoryList();

  console.log('catagories', categories);
  // console.log('successCallback', data, error);
  const { ref, inView } = useInView({
    threshold: 0
  });
  useEffect(() => {
    if (inView && hasNextPage && apiCallFlag.current) {
      apiCallFlag.current = false;
      fetchNextPage();
      // if (!isLoading) {
      //   fetchNextPage();
      // }
    }
  }, [inView, hasNextPage]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      className="centerModal dt_profileModal dt_createPlaylistModal px-0"
      size="lg"
      centered
      scrollable
    >
      <Modal.Header closeButton className="position-relative p-4 border-0 mb-1">
        <Modal.Title className="fs-3 text-black fw-semibold">Create Playlist</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex flex-column p-4">
        <div className="createForm_top">
          <FloatingLabel className="mb-4" controlId="floatingInput" label="Enter Playlist Name*">
            <Form.Control
              className="fs-4"
              placeholder="Enter Playlist Name*"
              onChange={(e) => setPlaylistName(e.target.value)}
            />
          </FloatingLabel>

          {categories && categories?.length > 0 && (
            <FloatingLabel controlId="floatingSelect" className="mb-4" label="Select Category*">
              <Form.Select
                className="fs-4"
                aria-label="Floating label select example"
                onChange={(e) => selectedCatagory(e.target.value)}
              >
                <option>Select Categories...</option>
                {categories?.map((_category, index) => (
                  <option value={_category.id} key={index+1}>{reactHtmlParser(_category?.name)}</option>
                ))}
              </Form.Select>
            </FloatingLabel>
          )}

          {categories && categories.length > 0 && (
            <FloatingLabel controlId="floatingSelect" className="mb-4" label="Select Sub Category*">
              <Form.Select
                className="fs-4"
                aria-label="Floating label select example"
                onChange={(e) => selectedSubcategory(e.target.value)}
                disabled={subCategories?.length == 0}
              >
                <option>Select Sub Categories...</option>
                {subCategories?.map((_category, index) => (
                  <option value={_category.id} key={index+1}>{reactHtmlParser(_category?.name)}</option>
                ))}
              </Form.Select>
            </FloatingLabel>
          )}

          {/* <div className="select_category mt-4 text-start">
            <label className="fs-4 fw-medium mb-2 text-black">Select Category*</label>
            {categories && (
              <MultiselectComponent
                id="category_select"
                // disabled={backdrop}
                options={categories?.length > 0 ? changeArrayToLabels(categories) : []}
                onChange={selectedCatagory}
              />
            )}
          </div>

          <div className="select_category my-4 text-start">
            <label className="fs-4 fw-medium mb-2 text-black">Select Sub Category*</label>
            {categories && (
              <MultiselectComponent
                id="subcategory_select"
                options={subCategories?.length > 0 ? changeArrayToLabels(subCategories) : []}
                onChange={selectedSubcategory}
                disabled={subCategories?.length == 0}
              />
            )}
          </div> */}

          <FloatingLabel
            className="mb-4"
            controlId="floatingInput"
            label="Enter Tags for easy discoverability*"
          >
            <Form.Control
              className="fs-4"
              placeholder="Enter Tags*"
              onChange={(e) => setTags(e.target.value)}
            />
          </FloatingLabel>
        </div>

        <div className={`searchForm position-relative d-flex flex-column ${isOpen ? 'open' : ''}`}>
          {/* 'open' className to add when the search input is on focus  */}
          <div className="d-flex justify-content-between position-relative">
            <Form.Control
              className="fs-16 fw-medium text-dark rounded px-4 border-light flex-1"
              type="text"
              placeholder="Search for videos..."
              onChange={handleSearch}
            // onFocus={() => setIsOpen(true)}
            // onBlur={() => setIsOpen(false)}
            />
            <a
              href="javascript:void(0)"
              className="text-dark bg-white searchBtn position-absolute top-50 translate-middle-y d-flex justify-content-center align-items-center"
            >
              <RiSearchLine customClass={'text-dark fs-3'} />
            </a>
          </div>

          {/* search history */}

          <div
            className="searchSuggestion text-start flex-grow-1 position-relative mt-3 w-100 bg-white shadow rounded-3 overflow-y-auto h-auto pb-50"
            id="modal-playlist"
          >
            {/* search history */}
            <div className="w-100 float-start searchSuggestionList list-unstyled border-bottom border-light">
              {filterData && filterData?.length > 0 ? (
                <>
                  {filterData?.map(
                    (_i, idx) => (
                      // !existedVideo.includes(_i?.id) && (
                      <li
                        className={`position-relative d-block ${videoIds.includes(_i?.id) ? 'selected' : ''
                          }`}
                        key={idx + 1}
                        onClick={(e) => addVideoHandler(_i)}
                      >
                        <span className="main_keyWord d-block">
                          <a
                            href="javascript:void(0)"
                            className="d-flex align-items-center p-4 pe-50 position-relative d-block text-dark"
                          >
                            <Form.Check
                              type="checkbox"
                              className="position-absolute top-50 translate-middle-y z-2"
                              label=""
                              checked={videoIds.includes(_i?.id)}
                              value={_i.tilte}
                              onClick={(e) => addVideoHandler(_i)}
                            />
                            <LazyImage
                              src={_i?.thumbnail}
                              className="object-fit-cover w-100 h-100 float-start"
                              extraClass="position-relative searchThumbnail rounded-3 overflow-hidden"
                            />
                            <div className="d-flex flex-column flex-1 ms-4">
                              {_i?.title && (
                                <h5 className="fs-4 fw-medium text-black line-clamp-2">
                                  {_i?.title}
                                </h5>
                              )}
                              {_i?.description && (
                                <p className="fs-5 fw-light text-black line-clamp-2">
                                  {`${_i?.description.length > 25
                                      ? `${_i?.description.slice(0, 30)}....`
                                      : _i?.description.slice(0, 20)
                                    }`}
                                </p>
                              )}
                            </div>
                          </a>
                        </span>
                      </li>
                    )
                    // )
                  )}
                </>
              ) : (
                !isLoading && (
                  <NoResult
                    mainText="Oops!"
                    subText={
                      filterData?.length > 0
                        ? `There are no videos with ${word} keyword.`
                        : `There are no videos to add to the ${playListName} playlist`
                    }
                  />
                )
              )}
              {hasNextPage && filterData?.length > 0 ? (
                <div className="w-100 float-start text-center">
                  <Loader type="ThreeDots" className="text-center text-primary opacity-75" color="currentColor" height={40} width={40} />
                </div>
              ) : (
                <></>
              )}
              {hasNextPage && apiCallFlag.current && <div ref={ref}>hello</div>}
            </div>
            {/* </InfiniteScroll> */}
            {/* search history  End*/}
          </div>
          {/* search history  End*/}
        </div>
      </Modal.Body>

      {videoIds.length > 0 && (
        <Modal.Footer className="border-0 px-4 shadow">
          <div className="d-flex dt_step_Submit w-100">
            <button
              type="button"
              className="rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-secondary fw-medium p-4"
              disabled={!(videoIds.length > 0) || disabled}
              // disabled={true}
              onClick={createPlaylist}
            >
              {disabled ? 'Please wait...' : 'Create Playlist'}
            </button>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default memo(CreatePlaylistModal);
